import { SyncEventType } from '../../enums/syncEventType';
import { Person } from '../../person';
import { RealtimeEvent } from './realtimeEvent';

export class EventTeammemberHighlightChanged implements RealtimeEvent {

  public readonly type = SyncEventType.WIDGET_TEAM_HIGHTLIGHT_CHANGED;
  public assignee: Person;
  public active: boolean;

  constructor(assignee: Person, active: boolean) {
    this.assignee = assignee;
    this.active = active;
  }

  getPayload(): object {
    const payload = {
      'assignee': this.assignee,
      'active': this.active
    };
    return payload;
  }

  static fromPayload(payload: any): EventTeammemberHighlightChanged {
    return new EventTeammemberHighlightChanged(
      payload['assignee'],
      payload['active']
    );
  }

}

